<div class="bg-white px-6 my-2 rounded-lg shadow w-full max-w-none flex flex-col overflow-hidden" style="height: calc(100vh - 60px)">
  <div class="flex flex-col md:flex-row md:gap-6 md:items-end mb-2">
    <div class="mb-4 md:mb-0">
      <label class="{{Skin.upperCaseSmallLabel}}">{{ 'entities.client.pluralName' | translate }}</label>
      <select [ngModel]="currentClient()" (ngModelChange)="onClientSelected($event)" class="{{Skin.formInputSmallSize}} w-72 md:w-80">
        <option [ngValue]="null" disabled>{{ 'Choose a client' | translate }}</option>
        @for (client of clients(); track client.id) {
        <option [ngValue]="client">{{ client.organizationName }}</option>
        }
      </select>
    </div>
    <div class="mb-4 md:mb-0">
      <label class="{{Skin.upperCaseSmallLabel}}">{{ 'entities.pointOfService.pluralName' | translate }}</label>
      <select [ngModel]="currentPosId()" (ngModelChange)="onPointOfServiceSelected($event)" [disabled]="!currentClient()"
        class="{{Skin.formInputSmallSize}} w-72 md:w-80">
        <option [ngValue]="null">{{ 'None' | translate }}</option>
        @for (pos of pointOfServices(); track pos.id) {
        <option [ngValue]="pos.id">{{ pos.name }}</option>
        }
      </select>
    </div>
    @if (currentClient()) {
    <div class="md:ml-auto">
      <input type="search" [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)"
        [placeholder]="'Search' | translate" class="{{Skin.formInputSmallSize}} w-72 md:w-80" />
    </div>
    }
  </div>

  @if (currentClient()) {
  <h1 class="text-lg font-medium text-gray-700 mb-2">
    {{ 'entities.overridetranslation.pluralName' | translate }} ({{ filteredRows().length }}/{{ rows().length }})
    @if (loading()) {
    <span class="text-sm text-gray-400 ml-2">{{ 'Loading...' | translate }}</span>
    }
  </h1>

  <div class="flex-1 min-h-0 flex flex-col border border-gray-200 rounded">
    <div class="override-grid override-header bg-gray-50 border-b border-gray-200 text-xs font-semibold uppercase text-gray-600"
      [style.grid-template-columns]="gridTemplate()">
      <div class="px-2 py-2">{{ 'entities.overridetranslation.propreties.id' | translate }}</div>
      @for (language of languages(); track language.id) {
      <div class="px-2 py-2">{{ 'entities.overridetranslation.propreties.translationValue-' + language.key | translate }}</div>
      }
    </div>

    @if (!loading() && filteredRows().length === 0) {
    <div class="p-4 text-sm text-gray-500">{{ 'No results found' | translate }}</div>
    }

    <cdk-virtual-scroll-viewport [itemSize]="rowHeight" class="flex-1 min-h-0">
      <div *cdkVirtualFor="let row of filteredRows(); trackBy: trackRow" class="override-grid border-b border-gray-100 text-sm"
        [style.grid-template-columns]="gridTemplate()" [style.height.px]="rowHeight">
        <div class="px-2 py-1 text-xs text-gray-500 break-all line-clamp-3" [title]="row.id">{{ row.id }}</div>
        @for (cell of row.cells; track cell.languageId) {
        <div class="px-1 py-1 min-w-0">
          @if (cell.isOverrided) {
          <div class="relative h-full">
            <textarea [(ngModel)]="cell.translationValue" (ngModelChange)="onValueChanged(row)" [title]="cell.originalValue"
              class="w-full h-full resize-none px-2 py-1 pr-8 text-sm border border-blue-300 bg-blue-50 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
            <button type="button" (click)="removeOverride(row, cell)" title="Restaurer la traduction originale"
              class="absolute right-1 top-1 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center">
              <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          } @else {
          <div (click)="makeEditable(cell)" [title]="cell.translationValue"
            class="h-full px-2 py-1 rounded cursor-pointer hover:bg-gray-100 line-clamp-2 break-words">
            {{ cell.translationValue }}
          </div>
          }
        </div>
        }
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="bg-white pt-4 pb-2 border-t border-gray-200 mt-4 -mx-6 px-6 flex items-center gap-3">
    <button (click)="saveTranslations()" [disabled]="saving() || loading() || !dirty()"
      class="bg-teal-500 hover:bg-teal-600 disabled:opacity-50 disabled:cursor-not-allowed text-white px-4 py-2 text-sm font-medium border border-gray-200 focus:outline-none">
      {{ 'buttons.save' | translate }}
    </button>
  </div>
  }
</div>
